'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersController = function () {

  /*@ngInject*/
  function UsersController(Users, users) {
    _classCallCheck(this, UsersController);

    this.user = {
      name: '',
      email: '',
      password: ''
    };
    this.errors = undefined;
    this.submitted = false;

    this._Users = Users;
    this.users = users;
  }

  _createClass(UsersController, [{
    key: 'create',
    value: function create() {
      var _this = this;

      this.submitted = true;
      this._Users.save(this.user).then(function (res) {
        _this.user = {};
        _this.submitted = false;
        _this.users.push(res);
      }).catch(function (err) {
        console.log(err);
        _this.errors = err.message;
      });
    }
  }, {
    key: 'destroy',
    value: function destroy(user) {
      var _this2 = this;

      this._Users.destroy(user).then(function () {
        var index = _this2.users.indexOf(user);
        _this2.users.splice(index, 1);
      }).catch(function (err) {
        console.log(err);
        _this2.errors = err.message;
      });
    }
  }]);

  return UsersController;
}();

exports.default = UsersController;


// WEBPACK FOOTER //
// ./client/app/admin/users.controller.js